import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';
import InputWindow from 'Flow2/components/UI/Overlay/InputWindow';

import Button from 'Flow2/components/UI/Button/Button';
import Input from 'Flow2/components/UI/Input/Input';
//import TagTree from 'Flow2/components/Article/Tags/TagTree';
import TagTree from 'porschearchiv/components/Stock/TagTree';
import SM from 'Flow2/util/StructureMapping.js';

import * as actions from 'store/actions/index';

import classes from './TagTreeDynamic.module.scss';

const FILTER_TAG_TREE = "FILTER_TAG_TREE";

const _FLOW_WINDOW_TAG_TREE_DYNAMIC_ = "_FLOW_WINDOW_TAG_TREE_DYNAMIC_";

export class StockWindow extends Component {
    constructor(props) {
        super(props);
        this.state = StockWindow.initState(props);
    }
    
    static initState(props) {
        const state = {};
  
        state.filter = {};
        state.tags = props.selected || [];
        state.keywords = props.keywords || [];
        state.elements = [];
        
        return state;
    }

	static getDerivedStateFromProps(props, state) {
        return null;
    }
    
    componentDidMount() {}
    
    componentDidUpdate(prevProps, prevState) {}
    
    componentWillUnmount() {}
    
    onCancel = () => {
        this.props.onClose();
    }
    
    getLevel = () => {
        let level = 1;
        this.state.elements.forEach(elm => {
            if(elm.level) {
                let lvl = parseInt(elm.level);
                if(level < lvl) {
                    level = lvl;
                }
            }
        });
        return level;
    }
    
    onSave = () => {
        //this.props.onSetupFields(this.state.checked);
        if(this.props.changeHandler) {
            this.props.changeHandler({
                keywords: this.state.keywords,
                tags: this.state.tags,
                level: this.getLevel()
            });
            
        }
        this.props.onClose();
    }
    
    onFilterChanged = (filter, value) => {
        let filters = this.state.filter;
        filters[filter] = value;
        this.setState({ filter: filters });
    }

    getFilter = (filter) => {
        return (
            <FlexRow className={classes.Filter}>
                <Input
                    className={'fullWidth'}
                    key={filter}
                    value={this.state.filter[filter] || ""}
                    elementConfig={{ type: 'text', placeholder: 'Filter' }}
                    changed={(event) => {
                        this.onFilterChanged(filter, event.target.value);
                    }}
                />
            </FlexRow>
        );
    }
    
    onLoaded = (tags = [], keywords = [], elements = []) => {
        //console.log(tags, keywords, elements);
        this.props.onLoaded && this.props.onLoaded(tags, keywords, elements);
    }
    
    onSelect = (tags = [], keywords = [], elements = []) => {
        //console.log(tags, keywords, elements);
        this.props.onSelect && this.props.onSelect(tags, keywords, elements);
        this.setState({ tags: tags, keywords: keywords, elements: elements });
    }
	
	renderContent =  () => {
        return (
            <div className={[classes.WindowContent, "fullWidth"].join(' ')}>
                <TagTree
                    title={this.props.config.TAG_TREE_TITLE}
                    selected={this.state.tags}
                    keywords={this.state.keywords}
                    onSelect={this.onSelect}
                    onLoaded={this.onLoaded}
                    singleSelect={this.props.singleSelect || false}
                    extraContent={this.getFilter(FILTER_TAG_TREE)}
                    filter={{ field: 'name', search: this.state.filter[FILTER_TAG_TREE] }} />
            </div>
        )
    }
    
    render = () => {
        return(
			<InputWindow 
                show={this.props.show} 
                content={this.renderContent()}
                title="Bestände"
                onSave={this.onSave}
                onCancel={this.props.onClose}/>
        )
    }
}

//const ListHeader = (props) => {
class TagTreeDynamic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }
    
    /*
    onShow = () => {
       this.setState({ show: true }); 
    }
    
    onClose = () => {
        this.setState({ show: false }); 
    }
    */
    onShow = (tag) => {
        this.props.setWindow(_FLOW_WINDOW_TAG_TREE_DYNAMIC_, this.renderWindow(tag));
        this.setState({ show: true }); 
    }
    
    onClose = () => {
        this.props.removeWindow(_FLOW_WINDOW_TAG_TREE_DYNAMIC_);
        this.setState({ show: false });
    }
    
    renderWindow = (tag) => {
        const element = this.props.element;
		
        /*let values = [];
		if(typeof element.value === 'string') {
			try {
				values = JSON.parse(element.value);
				if (!Array.isArray(values)) {
					throw new TypeError("No JSON Array: value in DisplayJSONArray");
				}
			} catch (ex) {
				values = [];
			}
		}*/
		/* ? element.value.split(';') : [];*/
        const ids = typeof this.props.ids === 'string' ? this.props.ids.split(';') : [];
        const values = [];
        ids.forEach(id => {
            if(this.props.list[id]) {
                values.push(this.props.list[id].name);
            }
        });
        
        return (
            <StockWindow 
                {...this.props} 
                show={true} 
                onClose={this.onClose}
                selected={ids}
                keywords={values}
                singleSelect={false}
                changeHandler={(values) => {
                    this.props.changeHandler({
                        [element.id]: JSON.stringify(values.keywords),
                        [this.props.reference]: values.tags.join(';'),
                        sichtbarlevel: values.level+"" || 1+""
                    });
                }}
            />
        );
        
    }
    
    
	render() {
        const element = this.props.element;
		//console.log(element);
        /*let values = [];
		if(typeof element.value === 'string') {
			try {
				values = JSON.parse(element.value);
				if (!Array.isArray(values)) {
					throw new TypeError("No JSON Array: value in DisplayJSONArray");
				}
			} catch (ex) {
				values = [];
			}
		}*/
		/* ? element.value.split(';') : [];*/
        const ids = typeof this.props.ids === 'string' ? this.props.ids.split(';') : [];
        const values = [];
        ids.forEach(id => {
            if(this.props.list[id]) {
                values.push(this.props.list[id].name);
            }
        });
        
        return (
            <>
            <FlexRow className={[classes.Input,"fullWidth"].join(' ')}>
                <Input
                    key={element.id}
                    value={values.join('; ')}
                    elementConfig={{ type: 'text', placeholder: SM.hasPlaceholder(element.obj) || "", readonly: true }}
                    changed={null}
                />
				<Button
                    key="ok"
                    btnType="Red"
                    clicked={this.onShow}>
                    <FontAwesomeIcon icon={faPen} className={['pointer'].join(' ')} title={this.props.intl.formatMessage({ id: "common.edit" })} />
                </Button>
			</FlexRow>
			{ /*this.state.show ?
                <StockWindow 
                    {...this.props} 
                    show={this.state.show} 
                    onClose={this.onClose}
                    selected={ids}
                    keywords={values}
                    singleSelect={false}
                    changeHandler={(values) => {
                        this.props.changeHandler({
                            [element.id]: JSON.stringify(values.keywords),
                            [this.props.reference]: values.tags.join(';'),
                            sichtbarlevel: values.level+"" || 1+""
                        });
                    }}
                />
                : ""*/
            }
            </>
        );
    }
};


const mapStateToProps = (state) => {
	return {
        config: state.ui.config,
        list: state.tags.treeList
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		setWindow: (id, elm) => dispatch(actions.setWindow(id, elm)),
		removeWindow: (id, elm) => dispatch(actions.removeWindow(id))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TagTreeDynamic));
